module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Semibold.0b98062c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Semibold.svg
// module id = 343
// module chunks = 3